import { useContext } from "react"

import { tableContext } from "../utils"

export function useData() {
  const { data, firstRow } = useContext(tableContext)

  return { data, firstRow }
}
